export { AppInstaller } from './AppInstaller.js';
export { getAppPreviewUrl } from './preview-url.js';
export { getSiteRedirectUrl } from './site-url.js';
export type { PlatformsType } from './redirect-service-url.js';
